<template>
<div class="formGroup">
  <formLabel :label="label" :validation="validation"></formLabel>
  <slot name="head-description"></slot>
  <textarea
    class="formControl"
    v-validate="validation"
    :class="{'error': errors.has(name)}"
    :name="name"
    :value="value"
    :maxlength="maxlength"
    :placeholder="placeholder"
    :rows="rows"
    :cols="cols"
    @input="update"
  ></textarea>

  <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
  <slot name="aside"></slot>
</div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-textarea',
  mixins: [mixin]
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormTextarea.vue